import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// LinkedIn-model refactor: /unlock is deprecated as a standalone gate page.
// All users now land on /profile/edit after onboarding. The "Publish to Directory" CTA
// lives prominently on Dashboard + Profile Editor for unpaid users.
// Kept here as a redirect for any external/bookmarked links.
export default function Unlock() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/profile/edit", { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center" data-testid="unlock-redirect">
      <p className="text-[#777] text-sm tracking-wide">Taking you to your profile…</p>
    </div>
  );
}
